// extracted by mini-css-extract-plugin
export default {"cls1":"hGU0G2Oot07T9owtuz4x","cls2":"g4JodfYXUcgwmAh9_9WU hGU0G2Oot07T9owtuz4x"};